module Meevo.Components.FileUpload {

    export class MeevoFileUploadService {

        static getImageUrl(imageData?: Meevo.Model.MeevoFile, defaultUrl: string = 'assets/images/icons/photo_not_available.svg', key: string = 'Source'): string {
            if (!imageData) {
                return defaultUrl;
            }

            let fileUrl: string = defaultUrl;
            (imageData.files || []).forEach(function (setting) {
                if (setting.key === key) {
                    fileUrl = setting.fileUrl;
                }
            });

            return fileUrl;
        }

    }

    angular
        .module('meevo.components.fileupload')
        .service('meevo.components.fileupload.MeevoFileUploadService', MeevoFileUploadService);

}
